import script from "./Button.vue?vue&type=script&lang=ts&setup=true"
export * from "./Button.vue?vue&type=script&lang=ts&setup=true"

import "./Button.vue?vue&type=style&index=0&id=28187f14&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/bookonline/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28187f14"]])

export default __exports__